import { dispatchCommand } from '@/services/messaging/dispatchCommand';

export function formLogin(username, password, code, token) {
  return dispatchCommand("FormLogin", {
    username: username,
    password: password,
    code: code,
    token: token
  });
}
